export const resolveDynamicQuery = (_ref, variables) => {
  let {
    resource,
    id,
    data,
    params
  } = _ref;
  return {
    resource,
    id: typeof id === 'function' ? id(variables) : id,
    data: typeof data === 'function' ? data(variables) : data,
    params: typeof params === 'function' ? params(variables) : params
  };
};